class Zoningareas extends Array {}

const zoningareas_api_adapter = zoningarea => zoningarea;

const zoningareas_list_api_adapter = zoningarea =>
    zoningarea.map(zoningareas_api_adapter);

const createZoningareasList = (data = []) => {
    const zoningareas = Zoningareas.from(data, zoningarea =>
        createZoningareas(zoningarea)
    );
    return zoningareas;
};

const zoningareas_view_adapter = zoningarea => {
    return zoningarea;
};

const createZoningareas = ({
    // areakm2 = null,
    // backgmap = null,
    // beginlsver = null,
    // coast_di_1 = null,
    // coast_dist = null,
    // dimind = null,
    // endlsver = null,
    id = null,
    geom = null,
    offsource = null,
    ms = null,
    hiluclu = null,
    hilucsmsp = null,
    seausename = null,
    seausefct = null,
    seausedsc = null,
    originun = null,
    originunen = null,

    // hilucspres = null,
    // layer = null,
    // localid = null,
    // objectid = null,
    // offdoc = null,
    // path = null,
    // prevmsppla = null,
    // procstepg = null,
    // regnature = null,
    // shape_area = null,
    // shape_leng = null,
    // speclanus = null,
    // specpres = null,
    // spid = null,
    // validfrom = null,
    // validto = null,
    // versionid = null,
    // vertdistr = null,
} = {}) => {
    const publicApi = {
        // areakm2,
        // backgmap,
        // beginlsver,
        // coast_di_1,
        // coast_dist,
        // dimind,
        // endlsver,
        // hilucspres,
        geom,
        hiluclu,
        hilucsmsp,
        id,
        seausedsc,
        seausefct,
        seausename,
        ms,
        offsource,
        originun,
        originunen,
        // layer,
        // localid,
        // objectid,
        // offdoc,
        // path,
        // prevmsppla,
        // procstepg,
        // regnature,

        // shape_area,
        // shape_leng,
        // speclanus,
        // specpres,
        // spid,
        // validfrom,
        // validto,
        // versionid,
        // vertdistr,
    };

    return Object.freeze(publicApi);
};

export {
    createZoningareas,
    createZoningareasList,
    zoningareas_api_adapter,
    zoningareas_list_api_adapter,
    zoningareas_view_adapter,
};
